var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GmailActionsOverTimeTooltip } from '@web/components/Apps/Gmail/GmailActionsOverTimeTooltip';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { ChartSeriesVisibility } from '@web/components/layout/RechartsItems/ChartSeriesVisibility';
import CustomTooltip from '@web/components/layout/RechartsItems/CustomTooltip';
import { createEdgePositionedBarTooltipContent } from '@web/components/layout/RechartsItems/EdgePositionedBarTooltip';
import LegendItem from '@web/components/layout/RechartsItems/LegendItem';
import { PeriodBarChart } from '@web/components/layout/RechartsItems/PeriodBarChart';
import { rechartsDiagonalStripeFillUrl } from '@web/components/layout/RechartsItems/rechartsDiagonalStripes';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { GMAIL_ACTIONS_OVER_TIME_BAR_CHART_CONFIGS, GMAIL_ACTIONS_OVER_TIME_COLORS_CONFIG, TablesDiffColorsConfig } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled } from '@web/utility';
import { createPeriodComparisonSeriesLabelFormatter, hasTeamAverageTotals } from '@web/utility/ tooltip/periodComparisonTooltip';
import { ComparisonPeriod, navigateToEventsLogFromPeriodChartBarClick } from '@web/utility/chartNavigation';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { ApplicationEnum, GMAIL_ACTIONS_OVER_TIME_KEYS, InsightTypeEnum } from '@workalizer/shared';
import { getInterval } from '@workalizer/shared/utils';
import { useTranslation } from 'react-i18next';
var seriesDataKey = function (prefix, key) { return "".concat(prefix).concat(key.charAt(0).toUpperCase()).concat(key.slice(1)); };
var gmailTeamStripePatternId = function (dataKey) {
    return "".concat(InsightTypeEnum.gmailActionsOverTime, "_").concat(dataKey);
};
function GmailActionsOverTime() {
    var _this = this;
    var t = useTranslation().t;
    var _a = useFilters(), dateFrom = _a.dateFrom, dateTo = _a.dateTo, orgUnit = _a.orgUnit, user = _a.user;
    var navigateTo = useNavigateTo();
    var _b = trpc.gmailActionsOverTime.useQuery({
        dateFrom: dateFrom,
        dateTo: dateTo,
        userId: user,
        orgUnitId: orgUnit
    }), data = _b.data, isLoading = _b.isLoading, refetch = _b.refetch;
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    var showTeamAverage = Boolean(user) && hasTeamAverageTotals(data.totals);
    var interval = getInterval(dateFrom, dateTo);
    var metricLabels = GMAIL_ACTIONS_OVER_TIME_KEYS.reduce(function (acc, key) {
        acc[key] = t("app.apps.gmail.actionsOverTime.series.".concat(key));
        return acc;
    }, {});
    var seriesLabelFormatter = createPeriodComparisonSeriesLabelFormatter(metricLabels);
    var previousStackDataKeys = GMAIL_ACTIONS_OVER_TIME_BAR_CHART_CONFIGS.previous.map(function (config) { return config.dataKey; });
    var currentStackDataKeys = GMAIL_ACTIONS_OVER_TIME_BAR_CHART_CONFIGS.current.map(function (config) { return config.dataKey; });
    var teamStackDataKeys = GMAIL_ACTIONS_OVER_TIME_BAR_CHART_CONFIGS.team.map(function (config) { return config.dataKey; });
    var tooltipSeriesOrder = showTeamAverage
        ? __spreadArray(__spreadArray(__spreadArray([], previousStackDataKeys, true), currentStackDataKeys, true), teamStackDataKeys, true) : __spreadArray(__spreadArray([], previousStackDataKeys, true), currentStackDataKeys, true);
    var teamStripePatterns = showTeamAverage
        ? GMAIL_ACTIONS_OVER_TIME_KEYS.map(function (key) {
            var teamDataKey = seriesDataKey('team', key);
            return {
                patternId: gmailTeamStripePatternId(teamDataKey),
                chartColor: GMAIL_ACTIONS_OVER_TIME_COLORS_CONFIG[key].teamChartColor
            };
        })
        : [];
    var stripeSwatchColors = showTeamAverage
        ? Object.fromEntries(GMAIL_ACTIONS_OVER_TIME_KEYS.map(function (key) {
            var teamDataKey = seriesDataKey('team', key);
            return [
                teamDataKey,
                GMAIL_ACTIONS_OVER_TIME_COLORS_CONFIG[key].teamChartColor
            ];
        }))
        : undefined;
    var chartData = data.periods.map(function (period) {
        var row = {
            period: period.period,
            previousPeriodLabel: period.previousPeriodLabel
        };
        for (var _i = 0, GMAIL_ACTIONS_OVER_TIME_KEYS_1 = GMAIL_ACTIONS_OVER_TIME_KEYS; _i < GMAIL_ACTIONS_OVER_TIME_KEYS_1.length; _i++) {
            var key = GMAIL_ACTIONS_OVER_TIME_KEYS_1[_i];
            row[seriesDataKey('current', key)] = period[key];
            var prevKey = "prev".concat(key.charAt(0).toUpperCase()).concat(key.slice(1));
            row[seriesDataKey('previous', key)] = period[prevKey];
            var teamKey = "team".concat(key.charAt(0).toUpperCase()).concat(key.slice(1));
            row[seriesDataKey('team', key)] = period[teamKey];
        }
        return row;
    });
    var renderTooltip = createEdgePositionedBarTooltipContent(showTeamAverage ? (_jsx(GmailActionsOverTimeTooltip, { seriesOrder: tooltipSeriesOrder, metricLabels: metricLabels, stripeSwatchColors: stripeSwatchColors, showTeamAverage: showTeamAverage, dateFrom: dateFrom, dateTo: dateTo, t: t })) : (_jsx(CustomTooltip, { seriesOrder: tooltipSeriesOrder, periodComparisonTooltip: true, seriesLabelFormatter: seriesLabelFormatter })), chartData.length);
    var legendItems = GMAIL_ACTIONS_OVER_TIME_KEYS.map(function (key) { return ({
        key: key,
        currentValue: data.totals[key].current,
        diffValue: data.totals[key].previous,
        teamAverage: showTeamAverage ? data.totals[key].teamAverage : undefined
    }); });
    var handleBarClick = function (stack, barData, fallbackIndex) {
        navigateToEventsLogFromPeriodChartBarClick({
            chartData: chartData,
            barData: barData,
            fallbackIndex: fallbackIndex,
            stack: stack,
            app: ApplicationEnum.GMAIL,
            navigateTo: navigateTo,
            dateFrom: dateFrom,
            dateTo: dateTo,
            userId: user,
            orgUnitId: orgUnit
        });
    };
    return (_jsxs("div", { children: [_jsx(WidgetTitle, { title: t('app.apps.gmail.actionsOverTime.title'), description: "widgetTitleDescriptions.apps.gmailActionsOverTime", insightType: InsightTypeEnum.gmailActionsOverTime, insightsData: data, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.apps.gmail.actionsOverTime.title'), onExportHandler: function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, data.periods.map(function (period) {
                                    var _a;
                                    var entry = (_a = {},
                                        _a[t('filters.period')] = period.period,
                                        _a);
                                    for (var _i = 0, GMAIL_ACTIONS_OVER_TIME_KEYS_2 = GMAIL_ACTIONS_OVER_TIME_KEYS; _i < GMAIL_ACTIONS_OVER_TIME_KEYS_2.length; _i++) {
                                        var key = GMAIL_ACTIONS_OVER_TIME_KEYS_2[_i];
                                        var label = t("app.apps.gmail.actionsOverTime.series.".concat(key));
                                        entry["".concat(t('export.current'), " ").concat(label)] = period[key];
                                        var prevKey = "prev".concat(key.charAt(0).toUpperCase()).concat(key.slice(1));
                                        entry["".concat(t('export.previous'), " ").concat(label)] = period[prevKey];
                                        if (showTeamAverage) {
                                            var teamKey = "team".concat(key.charAt(0).toUpperCase()).concat(key.slice(1));
                                            entry["".concat(t('export.teamAverage'), " ").concat(label)] = period[teamKey];
                                        }
                                    }
                                    return entry;
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(data) }) }), _jsx(ChartSeriesVisibility, __assign({ seriesKeys: GMAIL_ACTIONS_OVER_TIME_KEYS }, { children: function (_a) {
                    var toggleSeries = _a.toggleSeries, isSeriesVisible = _a.isSeriesVisible;
                    var chartStacks = __spreadArray([
                        {
                            stackId: '1',
                            segments: GMAIL_ACTIONS_OVER_TIME_BAR_CHART_CONFIGS.previous.map(function (config, index) { return ({
                                dataKey: config.dataKey,
                                fill: config.fill,
                                keyPrefix: "prev-".concat(config.dataKey),
                                hide: !isSeriesVisible(GMAIL_ACTIONS_OVER_TIME_KEYS[index]),
                                onClick: function (barData, barIndex) {
                                    return handleBarClick(ComparisonPeriod.Previous, barData, barIndex);
                                }
                            }); })
                        },
                        {
                            stackId: '2',
                            segments: GMAIL_ACTIONS_OVER_TIME_BAR_CHART_CONFIGS.current.map(function (config, index) { return ({
                                dataKey: config.dataKey,
                                fill: config.fill,
                                keyPrefix: "curr-".concat(config.dataKey),
                                hide: !isSeriesVisible(GMAIL_ACTIONS_OVER_TIME_KEYS[index]),
                                onClick: function (barData, barIndex) {
                                    return handleBarClick(ComparisonPeriod.Current, barData, barIndex);
                                }
                            }); })
                        }
                    ], (showTeamAverage
                        ? [
                            {
                                stackId: '3',
                                segments: GMAIL_ACTIONS_OVER_TIME_BAR_CHART_CONFIGS.team.map(function (config, index) { return ({
                                    dataKey: config.dataKey,
                                    fill: rechartsDiagonalStripeFillUrl(gmailTeamStripePatternId(config.dataKey)),
                                    keyPrefix: "team-".concat(config.dataKey),
                                    hide: !isSeriesVisible(GMAIL_ACTIONS_OVER_TIME_KEYS[index])
                                }); })
                            }
                        ]
                        : []), true);
                    return (_jsx(PeriodBarChart, { chartData: chartData, dateFrom: dateFrom, dateTo: dateTo, interval: interval, barsPerGroup: showTeamAverage ? 3 : 2, tooltipContent: renderTooltip, stripePatterns: teamStripePatterns, legend: _jsx("div", __assign({ className: "flex flex-col flex-wrap justify-start gap-2 lg:flex-row lg:gap-4" }, { children: legendItems.map(function (_a) {
                                var key = _a.key, currentValue = _a.currentValue, diffValue = _a.diffValue, teamAverage = _a.teamAverage;
                                return (_jsx(LegendItem, { color: GMAIL_ACTIONS_OVER_TIME_COLORS_CONFIG[key].color, label: t("app.apps.gmail.actionsOverTime.series.".concat(key)), currentValue: currentValue, diffValue: diffValue, teamAverage: teamAverage, stripeChartColor: teamAverage
                                        ? GMAIL_ACTIONS_OVER_TIME_COLORS_CONFIG[key]
                                            .teamChartColor
                                        : undefined, arrowColor: TablesDiffColorsConfig.GREEN, onClick: function () { return toggleSeries(key); }, isHidden: !isSeriesVisible(key) }, key));
                            }) })), stacks: chartStacks }));
                } }))] }));
}
export default GmailActionsOverTime;
